(ns rothko.form2.core
  (:require [medley.core :refer [map-vals]]))

(defn mark-all-fields-dirty!
  [!state field-settings]
  (swap! !state (fn [{:keys [:rothko.form2.component/fields] :as state}]
                  (let [fields (map-vals
                                (fn [field-settings]
                                  (assoc field-settings
                                         :rothko.form2.component/dirty? true))
                                fields)]
                    (assoc state :rothko.form2.component/fields fields)))))

(defn form-current
  [state]
  (let [{:keys [:rothko.form2.component/fields]} state]
    (map-vals :rothko.form2.component/current fields)))

(defn compute-disabled?
  [disabled? form-settings field-config]
  (cond
    (or (boolean? disabled?)
        (nil? disabled?))
    disabled?

    (ifn? disabled?)
    (disabled? form-settings field-config)

    :else
    (throw (ex-info "::disabled? is not one of: boolean, nil or ifn" {}))))
